import React from "react";

const PredictionSkeleton = () => {
  return (
    <div className="animate-pulse w-full h-[500px]">
      <div className="bg-gray-400 rounded-[24px] h-full">&ensp;</div>
    </div>
  );
};

export default PredictionSkeleton;
